import { TOOL_NAV_ITEMS } from '@/pages/ipe/workbench/constants/workbenchNavConfig';

function buildGroup(id, label, navIds) {
  const items = (navIds || [])
    .map((navId) => TOOL_NAV_ITEMS[navId])
    .filter(Boolean);
  if (!items.length) return null;
  return { id, label, items };
}

/** 详情页快捷工具栏白名单：主图创作 / AI文案 / 商品设计 */
/** 「商品刊登」下拉：与商品库页一致，拆成 SPU 刊登 / SPU 复色（labelKey 由工具栏按当前语言解析） */
const LISTING_PUBLISH_TOOL_ITEM = {
  id: 'platformListing',
  labelKey: 'platformListing.recolorPublishEntry',
};
const RECOLOR_TOOL_ITEM = {
  id: 'platformRecolor',
  labelKey: 'platformListing.recolorEntry',
};

function buildListingGroup() {
  const items = [LISTING_PUBLISH_TOOL_ITEM, RECOLOR_TOOL_ITEM].filter(Boolean);
  if (!items.length) return null;
  return { id: 'listing', labelKey: 'thirdParty.navListing', items };
}

const DETAIL_TOOLBAR_PRESETS = {
  goods: {
    hideExport: true,
    hideAddTemplate: true,
    groups: [
      buildGroup('copywriting', '', ['aiCopywriting']),
      buildListingGroup(),
      buildGroup('infringement', '', ['infringementDetection']),
    ].filter(Boolean),
  },
  aiCopywriting: {
    hideExport: true,
    hideAddTemplate: true,
    groups: [
      buildGroup('studio', '', ['goods']),
      buildListingGroup(),
      buildGroup('infringement', '', ['infringementDetection']),
    ].filter(Boolean),
  },
  podProductDesign: {
    hideExport: true,
    hideAddTemplate: true,
    showBatchReplace: true,
    showBatchFineTune: true,
    groups: [
      buildGroup('pod', '', ['goods', 'aiCopywriting']),
      buildListingGroup(),
      buildGroup('infringement', '', ['infringementDetection']),
    ].filter(Boolean),
  },
};

export function getDetailToolbarPreset(navId) {
  const key = String(navId || '').trim();
  return DETAIL_TOOLBAR_PRESETS[key] || null;
}

export function buildDetailToolbarBridgeGroups(navId) {
  const preset = getDetailToolbarPreset(navId);
  return preset?.groups?.length ? preset.groups : null;
}
